<template>
    <div
        class="tx-mobile-status"
        v-bind:class="`tx-mobile-status__${statusName}`"
    >
        <div class="tx-mobile-status-row skeleton" style="height: 22px" v-if="traceStatus === undefined">
            no status yet skeleton
        </div>
        <div class="tx-mobile-status-row" v-else>
            <span>
                <span class="muted" v-if="isPending">
                    {{ $t(`tx.status_pending`) }}
                </span>
                <span v-else-if="txDetails?.event === 'jetton_swap'">
                    {{ $t(`tx.status_${statusName}_exchange`) }}
                </span>
                <span v-else-if="['received_ton', 'sent_ton', 'nft_transfer', 'nft_purchase','sent_jetton', 'received_jetton'].includes(txDetails?.event)">
                    {{ $t(`tx.status_${statusName}_transfer`) }}
                </span>
                <span v-else>
                    {{ $t(`tx.status_${statusName}`) }}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['traceStatus', 'isPending', 'traceActions'],
    computed: {
        statusName() {
            if (this.isPending) return 'pending';
            if (this.traceStatus) return 'success';
            return 'failed';
        },

        txDetails() {
            if (!this.traceActions) return null;

            if (this.traceActions[0]?.simple_preview) {
                return this.traceActions[0]?.simple_preview;
            }
            return this.traceActions[0];
        },
    },
};
</script>

<style scoped lang="scss">
.tx-mobile-status {
    //padding: 3px 10px;
    //border-radius: 8px;
    &__success {
        color: var(--badge-green-color);
        //background-color: var(--success-status-transaction-background);
        //color: var(--success-status-transaction-border);
    }

    &__failed {
        color: var(--badge-red-color);
    }
}

.tx-mobile-status-icon {
    width: 24px;
    height: 24px;
}

.tx-mobile-status-row {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: 'Nunito';
    font-weight: 800;
    text-transform: uppercase;
    font-size: 16px;
}
</style>
